export default "__VITE_ASSET__CRZguWtc__"